import { SetupBedData, SetupSleeperData, SiqError } from "@models/app/helpers.model";
export interface SetupStateModel {
  selectedBedId: string | null;
  selectedSleeperId: string | null;
  selectedSide: number | null;
  dualBed: boolean | null;
  bedData: SetupBedData | null;
  sleeperData: SetupSleeperData | null;
  shouldAddSecondSleeper: number | null;
  isSettingFirstSleeper: boolean;
  loading: boolean;
  error: SiqError | null;
}

export const defaultSetupState = {
  selectedBedId: null,
  selectedSleeperId: null,
  selectedSide: null,
  dualBed: false,
  bedData: null,
  sleeperData: null,
  shouldAddSecondSleeper: null,
  isSettingFirstSleeper: false,
  loading: false,
  error: null
};